import Index from "views/Index.js";
import Profile from "views/examples/user/Profile.js";
import Maps from "views/examples/Maps.js";
import Register from "views/examples/authentication/Register.js";
import Login from "views/examples/authentication/Login.js";
import Reset from "views/examples/authentication/Reset.js";
import Forgot from "views/examples/authentication/Forgot.js";
import Tables from "views/examples/Tables.js";
import Icons from "views/examples/Icons.js";
import Feature from "./views/examples/Feature";
import UserSummary from "./views/examples/user/UserSummary";
import PurchaseUserDetails from "./views/examples/user/PurchaseUserDetails";

var routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    //component: Index,
    component: Feature,
    layout: "/admin",
  },
  {
    path: "/icons",
    name: "Icons",
    icon: "ni ni-planet text-blue",
    component: Icons,
    layout: "/admin",
  },
  {
    path: "/maps",
    name: "Maps",
    icon: "ni ni-pin-3 text-orange",
    component: Maps,
    layout: "/admin",
  },
  {
    path: "/user-profile",
    name: "User Profile",
    icon: "ni ni-single-02 text-yellow",
    component: Profile,
    layout: "/admin",
  },
  {
    path: "/tables",
    name: "Tables",
    icon: "ni ni-bullet-list-67 text-red",
    component: Tables,
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: Login,
    layout: "/auth",
  },
  {
    path: "/forgot",
    name: "Forgot",
    icon: "ni ni-key-25 text-info",
    component: Forgot,
    layout: "/auth",
  },
  {
    path: "/reset",
    name: "Reset",
    icon: "ni ni-key-25 text-info",
    component: Reset,
    layout: "/auth",
  },
  {
    path: "/manage-features",
    name: "Features",
    icon: "ni ni-bullet-list-67 text-blue",
    component: Feature,
    layout: "/admin",
  },
  {
    path: "/register",
    name: "Register",
    icon: "ni ni-circle-08 text-pink",
    component: Register,
    layout: "/auth",
  },
  {
    path: "/users/details",
    name: "UserSummary",
    icon: "ni ni-circle-08 text-pink",
    component: UserSummary,
    layout: "/admin",
  },
  {
    path: "/users/purchase/details",
    name: "Purchase",
    icon: "ni ni-circle-08 text-pink",
    component: PurchaseUserDetails,
    layout: "/admin",
  },
];
export default routes;
